export const UserActivityAction = {
  AccountInfoSelection: 'Account Info Selection',
  ClaimStatusHover: 'Claim status hover',
  DocumentDownloaded: 'Document Downloaded',
  DownloadPackage: 'Download Package',
  MvcCancel: 'MVC-Cancel',
  MvcEdit: 'MVC-Edit',
  MvcSave: 'MVC-Save',
  MvcSubmit: 'MVC-Submit',
  PreviewPackage: 'Preview Package',
  PrivacyPolicySelection: 'Privacy Policy Selection',
  ReadMessage: 'Read Message',
  ReviewAndSign: 'Review and Sign',
  SettlementAssistant: 'Settlement Assistant',
  TermsOfUse: 'Terms of Use',
  TrackOutboundShipment: 'Track outbound shipment',
  TrackReturnShipment: 'Track return shipment',
  VehicleSelectionChange: 'Vehicle selection Change',
  ViewLess: 'View Less',
  ViewMore: 'View More',
} as const

export type UserActivityActionValue =
  (typeof UserActivityAction)[keyof typeof UserActivityAction]

export interface UserActivityLogPayload {
  WorkOrderId?: string
  UserId?: string
  WorkOrderNoteId?: string
  WorkOrderDocPath?: string
  WorkOrderShippingId?: string
  TrackingNumber?: string
  Action: UserActivityActionValue
  HoveredStatus?: string
  EnvelopeId?: string
}
